import { DatePicker, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { columnChartConfigurationOptions } from "../../config";
import { disableFutureDates } from "../../services/util";

const { Option } = Select;

function TicketByProject() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [defaultYear, setDefaultYear] = useState(moment());
    const [formData, setFormData] = useState({
        staff_id,
        workauthor_id: "",
        range_year: defaultYear.get("year"),
    });
    const [assignee, setAssignee] = useState([]);
    const [chartData, setChartData] = useState([]);

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "ticketByProjects",
        async () => {
            return await HTTP("/analytics/geJiraTicketsByProjects", {
                ...formData,
            });
        },
        { enabled: false },
    );

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => {
            return await HTTP("/analytics/getJiraAssignees", { staff_id });
        },
        { enabled: false },
    );

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        getChart();
        fetchWorkLogAuthor();
    }, []);

    useEffect(() => {
        if (chartStatus === "success") {
            const { data: chartData } = chartRes;
            setChartData(chartData);
        }
    }, [chartStatus, chartRes]);

    useEffect(() => {
        getChart();
    }, [formData]);

    function handleYearChange(date, dateString) {
        const yearSelected = dateString || moment().get("year");
        setDefaultYear(dateString === "" ? moment() : moment(dateString));
        const updatedFormData = {
            ...formData,
            range_year: yearSelected,
        };
        setFormData(updatedFormData);
    }

    function handleAssigneeSelectionChange(e) {
        let workauthor_id = "";
        if (e !== undefined) {
            [workauthor_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            workauthor_id,
        };
        setFormData(updatedFormData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <DatePicker
                    className="year-picker"
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                />

                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    className="jira-dashboard-select"
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </div>
            {chartData.length > 0 ? (
                <Chart
                    legendToggle
                    className="charts"
                    chartType="ColumnChart"
                    height="95vh"
                    options={{
                        ...columnChartConfigurationOptions,
                        title: "Tickets By Project",
                        isStacked: true,
                    }}
                    data={chartData}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}

export default TicketByProject;
